import React from "react";

export const GoogleLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width="32px"
    height="32px"
  >
    <path
      fill="#FFC107"
      d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
    />
    <path
      fill="#FF3D00"
      d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
    />
    <path
      fill="#4CAF50"
      d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
    />
    <path
      fill="#1976D2"
      d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
    />
  </svg>
);

export const ZoomSmallImg = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.25"
      y="1.25"
      width="10.5"
      height="10.5"
      rx="2.75"
      stroke="white"
      strokeWidth="2.5"
    />
  </svg>
);

export const ZoomBigImg = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.25"
      y="1.25"
      width="16.5"
      height="16.5"
      rx="2.75"
      stroke="white"
      strokeWidth="2.5"
    />
  </svg>
);

export const FitImageImg = () => (
  <svg
    width="22"
    height="25"
    viewBox="0 0 22 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.379 0.952467C10.586 0.729573 10.793 0.655273 11.0691 0.655273C11.3451 0.655273 11.5521 0.878169 11.6211 0.952467C11.8281 1.17536 11.8972 1.39826 11.8972 1.69545V6.15334L13.0013 4.96457C13.4153 4.51878 14.0364 4.59308 14.3815 4.96457C14.7955 5.41036 14.7265 6.07904 14.3815 6.45053L11.6901 9.34816C11.2761 9.79395 10.655 9.71965 10.31 9.34816L7.61862 6.45053C7.20457 6.00474 7.27358 5.33606 7.61862 4.96457C8.03267 4.51878 8.65375 4.59308 8.99879 4.96457L10.1029 6.15334V1.69545C10.1029 1.39826 10.2409 1.10106 10.379 0.952467ZM10.379 24.3581C10.586 24.581 10.793 24.6553 11.0691 24.6553C11.3451 24.6553 11.5521 24.4324 11.6211 24.3581C11.8281 24.1352 11.8972 23.9123 11.8972 23.6151V19.1572L13.0013 20.346C13.4153 20.7918 14.0364 20.7175 14.3815 20.346C14.7955 19.9002 14.7265 19.2315 14.3815 18.86L11.6901 15.9624C11.2761 15.5166 10.655 15.5909 10.31 15.9624L7.61862 18.86C7.20457 19.3058 7.27358 19.9745 7.61862 20.346C8.03267 20.7918 8.65375 20.7175 8.99879 20.346L10.1029 19.1572V23.6151C10.1029 23.9123 10.2409 24.2095 10.379 24.3581ZM0 12.5802C0 12.8813 0.0681067 13.1071 0.272427 13.333C0.40864 13.4835 0.681066 13.6341 0.953493 13.6341L5.03989 13.6341L3.95019 14.8386C3.60965 15.215 3.54155 15.8926 3.95019 16.3443C4.29072 16.7207 4.90368 16.796 5.31232 16.3443L7.96848 13.4083C8.30902 13.0319 8.37712 12.3543 7.96848 11.9026L5.31232 8.96662C4.97179 8.59021 4.35883 8.51493 3.95019 8.96662C3.60965 9.34303 3.54155 10.0206 3.95019 10.4723L5.03989 11.6768H0.953493C0.681067 11.6768 0.476747 11.7521 0.272427 11.9779C0.20432 12.0532 0 12.279 0 12.5802ZM21.7276 13.333C21.9319 13.1071 22 12.8813 22 12.5802C22 12.279 21.7957 12.0532 21.7276 11.9779C21.5233 11.7521 21.3189 11.6768 21.0465 11.6768H16.9601L18.0498 10.4723C18.4585 10.0206 18.3903 9.34303 18.0498 8.96662C17.6412 8.51493 17.0282 8.59021 16.6877 8.96662L14.0315 11.9026C13.6229 12.3543 13.691 13.0319 14.0315 13.4083L16.6877 16.3443C17.0963 16.796 17.7093 16.7207 18.0498 16.3443C18.4585 15.8926 18.3903 15.215 18.0498 14.8386L16.9601 13.6341L21.0465 13.6341C21.3189 13.6341 21.5914 13.4835 21.7276 13.333Z"
      fill="white"
    />
  </svg>
);

export const FitOutImageImg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 0H4.5C2 0 0 2 0 4.5V19.5C0 22 2 24 4.5 24H19.5C22 24 24 22 24 19.5V4.5C24 2 22 0 19.5 0ZM21.9 19.5C21.9 20.8 20.8 21.9 19.5 21.9H4.5C3.2 21.9 2.1 20.8 2.1 19.5V4.5C2.1 3.2 3.2 2.1 4.5 2.1H19.5C20.8 2.1 21.9 3.2 21.9 4.5V19.5Z"
      fill="white"
    />
    <path
      d="M18.1 4.8999H14.2C13.7 4.8999 13.3 5.2999 13.3 5.7999V5.8999C13.4 6.3999 13.7 6.6999 14.2 6.6999H15.8L12.8 9.6999C12.6 9.8999 12.5 10.0999 12.5 10.3999C12.5 10.5999 12.6 10.8999 12.8 11.0999C13 11.2999 13.2 11.3999 13.5 11.3999C13.7 11.3999 14 11.2999 14.2 11.0999L17.2 8.0999V9.6999C17.2 10.1999 17.6 10.6999 18.2 10.6999C18.7 10.6999 19.2 10.2999 19.2 9.6999V5.7999C19.1 5.2999 18.7 4.8999 18.1 4.8999Z"
      fill="white"
    />
    <path
      d="M11.2 12.8C11 12.6 10.8 12.5 10.5 12.5C10.3 12.5 9.99999 12.6 9.79999 12.8L6.79999 15.8V14.2C6.79999 13.7 6.39999 13.2 5.79999 13.2C5.29999 13.2 4.79999 13.6 4.79999 14.2V18.1C4.79999 18.6 5.19999 19.1 5.79999 19.1H9.69999C10.2 19.1 10.7 18.7 10.7 18.1C10.7 17.6 10.3 17.1 9.69999 17.1H8.09999L11.1 14.1C11.3 13.9 11.4 13.7 11.4 13.4C11.4 13.3 11.4 13 11.2 12.8Z"
      fill="white"
    />
  </svg>
);

export const FlipImageImg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.4546 19.6365H15.2728V21.8183H17.4546V19.6365Z" fill="white" />
    <path
      d="M2.18182 4.36367V19.6364C2.18182 20.8419 3.15817 21.8183 4.36366 21.8183H8.72728V19.6364H4.36361V4.36367H8.72723V2.18188H4.36361C3.15817 2.18188 2.18182 3.15823 2.18182 4.36367Z"
      fill="white"
    />
    <path
      d="M13.0909 22.9091V1.09091C13.0909 0.488417 12.6025 0 12 0C11.3975 0 10.9091 0.488416 10.9091 1.09091V22.9091C10.9091 23.5116 11.3975 24 12 24C12.6025 24 13.0909 23.5116 13.0909 22.9091Z"
      fill="white"
    />
    <path
      d="M19.6364 2.18188V4.36372H21.8182C21.8182 3.15823 20.8418 2.18188 19.6364 2.18188Z"
      fill="white"
    />
    <path d="M21.8182 10.9092H19.6364V13.091H21.8182V10.9092Z" fill="white" />
    <path d="M17.4546 2.18188H15.2728V4.36372H17.4546V2.18188Z" fill="white" />
    <path d="M21.8182 6.54541H19.6364V8.72725H21.8182V6.54541Z" fill="white" />
    <path d="M21.8182 15.2727H19.6364V17.4545H21.8182V15.2727Z" fill="white" />
    <path
      d="M19.6364 21.8183C20.8418 21.8183 21.8182 20.842 21.8182 19.6365H19.6364V21.8183Z"
      fill="white"
    />
  </svg>
);

export const RotateImageImg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      transform="scale(1, -1) translate(0, -24)"
      d="M12.0005 23.6008C18.6173 23.6008 24 18.2175 24 11.6008C24 8.50296 22.7984 5.5402 20.677 3.31681C20.677 3.31681 20.986 2.62177 21.3686 1.76437C21.7503 0.906972 21.2009 0.301942 20.1407 0.412432L13.9315 1.0629C12.8712 1.17362 12.519 1.96275 13.1451 2.82549L16.813 7.87863C17.4397 8.74121 18.2125 8.84464 18.5401 8.10911L19.1333 6.77788C20.0885 8.19135 20.6224 9.86417 20.6224 11.6008C20.6224 16.3558 16.7546 20.223 12.0006 20.223C7.24577 20.223 3.37773 16.3553 3.37773 11.6008C3.37773 10.103 3.76696 8.62836 4.50438 7.33677C4.96666 6.52653 4.68486 5.49523 3.87463 5.03303C3.06415 4.57035 2.03333 4.85254 1.57065 5.66325C0.543272 7.46343 0 9.51653 0 11.6007C0 18.2175 5.38343 23.6008 12.0005 23.6008Z"
      fill="white"
    />
  </svg>
);

export const AddDocumentSVG = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 13.5H14.25V12.75C14.25 12.5511 14.171 12.3603 14.0303 12.2197C13.8897 12.079 13.6989 12 13.5 12C13.3011 12 13.1103 12.079 12.9697 12.2197C12.829 12.3603 12.75 12.5511 12.75 12.75V13.5H12C11.8011 13.5 11.6103 13.579 11.4697 13.7197C11.329 13.8603 11.25 14.0511 11.25 14.25C11.25 14.4489 11.329 14.6397 11.4697 14.7803C11.6103 14.921 11.8011 15 12 15H12.75V15.75C12.75 15.9489 12.829 16.1397 12.9697 16.2803C13.1103 16.421 13.3011 16.5 13.5 16.5C13.6989 16.5 13.8897 16.421 14.0303 16.2803C14.171 16.1397 14.25 15.9489 14.25 15.75V15H15C15.1989 15 15.3897 14.921 15.5303 14.7803C15.671 14.6397 15.75 14.4489 15.75 14.25C15.75 14.0511 15.671 13.8603 15.5303 13.7197C15.3897 13.579 15.1989 13.5 15 13.5ZM9.75 15H4.5C4.30109 15 4.11032 14.921 3.96967 14.7803C3.82902 14.6397 3.75 14.4489 3.75 14.25V3.75C3.75 3.55109 3.82902 3.36032 3.96967 3.21967C4.11032 3.07902 4.30109 3 4.5 3H8.25V5.25C8.25 5.84674 8.48705 6.41903 8.90901 6.84099C9.33097 7.26295 9.90326 7.5 10.5 7.5H12.75V9.75C12.75 9.94891 12.829 10.1397 12.9697 10.2803C13.1103 10.421 13.3011 10.5 13.5 10.5C13.6989 10.5 13.8897 10.421 14.0303 10.2803C14.171 10.1397 14.25 9.94891 14.25 9.75V6.75C14.25 6.75 14.25 6.75 14.25 6.705C14.2422 6.6361 14.2271 6.56822 14.205 6.5025V6.435C14.1689 6.35788 14.1208 6.287 14.0625 6.225L9.5625 1.725C9.5005 1.66666 9.42962 1.61856 9.3525 1.5825C9.32769 1.57816 9.30231 1.57816 9.2775 1.5825C9.20457 1.5435 9.1262 1.51569 9.045 1.5H4.5C3.90326 1.5 3.33097 1.73705 2.90901 2.15901C2.48705 2.58097 2.25 3.15326 2.25 3.75V14.25C2.25 14.8467 2.48705 15.419 2.90901 15.841C3.33097 16.2629 3.90326 16.5 4.5 16.5H9.75C9.94891 16.5 10.1397 16.421 10.2803 16.2803C10.421 16.1397 10.5 15.9489 10.5 15.75C10.5 15.5511 10.421 15.3603 10.2803 15.2197C10.1397 15.079 9.94891 15 9.75 15ZM9.75 4.0575L11.6925 6H10.5C10.3011 6 10.1103 5.92098 9.96967 5.78033C9.82902 5.63968 9.75 5.44891 9.75 5.25V4.0575ZM6 6C5.80109 6 5.61032 6.07902 5.46967 6.21967C5.32902 6.36032 5.25 6.55109 5.25 6.75C5.25 6.94891 5.32902 7.13968 5.46967 7.28033C5.61032 7.42098 5.80109 7.5 6 7.5H6.75C6.94891 7.5 7.13968 7.42098 7.28033 7.28033C7.42098 7.13968 7.5 6.94891 7.5 6.75C7.5 6.55109 7.42098 6.36032 7.28033 6.21967C7.13968 6.07902 6.94891 6 6.75 6H6ZM9.75 12H6C5.80109 12 5.61032 12.079 5.46967 12.2197C5.32902 12.3603 5.25 12.5511 5.25 12.75C5.25 12.9489 5.32902 13.1397 5.46967 13.2803C5.61032 13.421 5.80109 13.5 6 13.5H9.75C9.94891 13.5 10.1397 13.421 10.2803 13.2803C10.421 13.1397 10.5 12.9489 10.5 12.75C10.5 12.5511 10.421 12.3603 10.2803 12.2197C10.1397 12.079 9.94891 12 9.75 12ZM10.5 9H6C5.80109 9 5.61032 9.07902 5.46967 9.21967C5.32902 9.36032 5.25 9.55109 5.25 9.75C5.25 9.94891 5.32902 10.1397 5.46967 10.2803C5.61032 10.421 5.80109 10.5 6 10.5H10.5C10.6989 10.5 10.8897 10.421 11.0303 10.2803C11.171 10.1397 11.25 9.94891 11.25 9.75C11.25 9.55109 11.171 9.36032 11.0303 9.21967C10.8897 9.07902 10.6989 9 10.5 9Z"
      fill="white"
    />
  </svg>
);